import { axios } from '@/library/axios';
import { cookiesStorage } from '@/library/storage';
import type { BaseResponse } from '@/types/axios';

const DownloadReceiptService = {
  getS3Url: async (id: string): Promise<any> => {
    // const endpoint =
    //   import.meta.env.VITE_API_ENDPOINT_V1 +
    //   `public-original-urls?shortUrl=${id}`;
    const userId = cookiesStorage.getCookie('om-auth-user-id');
    // return await BaseService.request("GET", endpoint, {}, {});
    return axios<
      { invoiceUrl: String },
      BaseResponse<{ invoiceUrl: String }>,
      void
    >({
      url: `/dg/customers/${userId}/transactions/${id}/invoices`,
      method: 'get',
      // headers : headers
    });
  },
  getS3PublicUrl: async (id: string): Promise<any> => {
    // const userId = cookiesStorage.getCookie("om-auth-user-id");
    return axios<
      { invoiceUrl: String },
      BaseResponse<{ invoiceUrl: String }>,
      void
    >({
      url: `/public-original-urls?shortUrl=${id}`,
      method: 'get',
    });
  },

  downloadFile: async (url: string): Promise<any> => {
    fetch(url, {
      // headers: {
      //   Host: "https://om-v1-infra-dev-1-0-0-b-store.s3.ap-south-1.amazonaws.com",
      // },
    })
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((uril) => {
        const link = document.createElement('a');
        link.href = uril;
        link.download = 'Res.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  },
  downloadPublicFile: async (url: string): Promise<any> => {
    fetch(url, {
      // headers: {
      //   Host: "https://om-v1-infra-dev-1-0-0-b-store.s3.ap-south-1.amazonaws.com",
      // },
    })
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((uril) => {
        const link = document.createElement('a');
        link.href = uril;
        link.download = 'Res.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  },
};

export default DownloadReceiptService;
